import { set } from "date-fns";
import { ItemImage, ItemImageFile, ItemModel } from "../models/ItemModel";
import itemService from "../services/itemService";
import { UploadResult } from "./useImageUpload";

export const usePrimaryImageHandler = () => {
    const assignPrimaryImage = (item:ItemModel, images:(ItemImageFile | ItemImage)[], uploadResult: UploadResult[] = []):boolean => {
        let setPrimaryImage = false;
        // If the primary image is not set, set it to the first image in the list
        if (!item.primaryImage) {
            if (images[0] instanceof ItemImageFile) {
                const matched = uploadResult.find(i => i.clientFileName === (images[0] as ItemImageFile).file.name)
                item.primaryImage = matched?.fileName || "";
            }
            else {
                item.primaryImage = images[0].fileName || "";
            }
            setPrimaryImage = true;
        }
        else {
            // Check if the primary image is already in the list of images
            const imageName = item.primaryImage;
            const isExisting = images.find(i => (i instanceof ItemImage && i.fileName === imageName)) ? true : false;
            if (!isExisting) {
                // if not, fin the primary image in the upload result
                item.primaryImage = uploadResult.find(i => i.clientFileName === imageName)?.fileName || "";
                setPrimaryImage = true;
            }
            else {
                setPrimaryImage = true; 
            }
        }

        return setPrimaryImage;
    }

    const updatePrimaryImage = async (item: ItemModel,images:(ItemImageFile | ItemImage)[],  uploadResult: UploadResult[] = []) => {
        // Assign the primary image based on the upload result or existing images
        const updatePrimaryImage = assignPrimaryImage(item, images, uploadResult);

        if (item.primaryImage ) {
            if(updatePrimaryImage)
                return await itemService.updateItemPrimaryImage(item.itemId, item.primaryImage);
        }
        else {
            throw new Error("Primary image is not set. Please select an image.");
        }

    } 

    return {
        updatePrimaryImage}


}